import StylovyzeDialog from '@innovyze/stylovyze/lib/components/StylovyzeDialog';
import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import * as Styled from './NavigationPrompt.styles';
import { useGlobalization } from '../../contexts/GlobalizationProvider';
const NavigationPrompt = ({ title, content, cancelText, confirmText, secondaryConfirmText, when, navigate, shouldBlockNavigation, onNavigateAway, onSecondaryNavigateAway, shouldBlockReload, otherActions, }) => {
    const { t } = useGlobalization();
    const [dialogOpen, setDialogOpen] = useState(false);
    const [lastLocation, setLastLocation] = useState(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);
    const handleCancel = () => {
        setDialogOpen(false);
    };
    const i18nTitle = title ||
        t('Leave without saving?', {
            context: 'default navigation prompt title',
        });
    const i18nContent = content ||
        t('You have unsaved changes. Are you sure you want to leave this page without saving?', {
            context: 'default navigation prompt content',
        });
    const i18nCancel = cancelText ||
        t('Cancel', { context: 'default navigation prompt cancel button' });
    const i18nConfirm = confirmText ||
        t('Confirm', { context: 'default navigation prompt confirm button' });
    const handleConfirm = () => {
        setDialogOpen(false);
        if (onNavigateAway)
            onNavigateAway();
        setConfirmedNavigation(true);
    };
    const handleSecondaryConfirm = () => {
        setDialogOpen(false);
        if (onSecondaryNavigateAway)
            onSecondaryNavigateAway();
        setConfirmedNavigation(true);
    };
    const otherActionButtons = otherActions?.map(button => {
        const newOnClick = () => {
            setDialogOpen(false);
            if (button.onClick)
                button.onClick();
            setConfirmedNavigation(true);
        };
        return { ...button, onClick: newOnClick };
    });
    const handleBlockedNavigation = (nextLocation) => {
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
            setLastLocation(nextLocation);
            setDialogOpen(true);
            return false;
        }
        return true;
    };
    useEffect(() => {
        if (confirmedNavigation && lastLocation) {
            // Navigate to the previous blocked location with your navigate function
            navigate(lastLocation.pathname);
        }
    }, [confirmedNavigation, lastLocation]);
    const onBeforeUnload = (e) => {
        e.preventDefault();
        e.returnValue = '';
    };
    const onUnload = () => {
        if (onNavigateAway)
            onNavigateAway();
    };
    useEffect(() => {
        if (shouldBlockReload) {
            window.addEventListener('beforeunload', onBeforeUnload);
            window.addEventListener('unload', onUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
            window.removeEventListener('unload', onUnload);
        };
    }, [shouldBlockReload]);
    return (React.createElement(Styled.Wrapper, null,
        React.createElement(Prompt, { when: when, message: handleBlockedNavigation }),
        React.createElement(StylovyzeDialog, { open: dialogOpen, title: i18nTitle, content: i18nContent, cancelText: i18nCancel, confirmText: i18nConfirm, secondaryConfirmText: secondaryConfirmText, onCancel: handleCancel, onConfirm: handleConfirm, onSecondaryConfirm: handleSecondaryConfirm, dividers: "both", otherActions: otherActionButtons })));
};
NavigationPrompt.defaultProps = {
    shouldBlockReload: false,
    onNavigateAway: undefined,
};
export default NavigationPrompt;
